<template>
    <CModal @mtdclosemodal="mtdClose" :show="boo_modal" :close-on-backdrop="false" :centered="false" :title="title" :size="'md'" :btn_cancel="true" :btn_ok="true" :booTitile="true">
        <div class="px-3">
            <div class="row mx-0 px-0">
                <div class="mb-2 col-xl-12 px-1">
                    <label for="name" class="form-label">Diseño</label>
                    <input type="text" class="form-control form-control-sm" v-model="data_detail.name" placeholder="Nombre">
                </div>
                
                <div class="mb-2 col-xl-12 px-1">
                    <label for="logo" class="form-label">Logo</label>
                    <input type="file" class="form-control form-control-sm" ref="logoInput" @change="uploadImage($event, 'logo')" accept="image/*">
                </div>
                
                <div class="mb-2 col-xl-12 px-1">
                    <label for="grabado" class="form-label">Grabado</label>
                    <input type="file" class="form-control form-control-sm" ref="grabadoInput" @change="uploadImage($event, 'grabado')" accept="image/*">
                </div>
                
                <div class="col-md-12 mt-3 pt-1" v-if="num === 1">
                    <div class="form-check form-switch">
                        <input class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckChecked" v-model="data_detail.state" :checked="data_detail.state == 1" aria-checked="false" />
                        <label class="form-check-label" for="flexSwitchCheckChecked">
                            {{ data_detail.state == 1 ? 'Activo' : 'Inactivo' }}
                        </label>
                    </div>
                </div>
            </div>
        </div>
        <template #footer>
            <button class="btn btn-success btn-sm" @click="DataDetail" :disabled="cpButton">
                {{ (num == 0 ) ? 'Registrar':'Editar' }}
            </button>
            &nbsp;
        </template>
    </CModal>
</template>

<script>
import CModal from "../../shared/modals/CModal.vue";
import { mapActions } from "vuex";

export default {
    name: "c-maintenance-modal-documento",
    components: {
        CModal,
    },
    data() {
        return {
            data_detail: {
                name: '',
                state: '',
                campu_id: '',
                logo: null,
                grabado: null,
            },
        };
    },
    watch: {
        payload: {
            handler(newVal) {
                if(this.num == 1 && newVal) {
                    this.data_detail = { ...newVal };
                    // console.log(newVal)
                }
            },
            immediate: true,
        },
        num(newVal) {
            if (newVal === 0) {
                this.data_detail.campu_id = this.$store.getters.get__campus;
            }
        }
    },
    props: {
        title: String,
        boo_modal: Boolean,
        num: Number,
        payload: {
            type: Object,
            default: null
        },
        dataCampus: {
            type: Array,
            default: null
        },
    },
    computed: {
        cpButton() {
            return !(this.data_detail.name != '' && this.data_detail.logo != null);    
        }
    },
    methods: {
        ...mapActions(["get", "post"]),
        mtdClose() {
            this.data_detail = { name: '', state: '', campu_id: '', logo: null, grabado: null };
            if (this.$refs.logoInput) this.$refs.logoInput.value = "";
            if (this.$refs.grabadoInput) this.$refs.grabadoInput.value = "";
            this.$emit("closeModal");
        },
        DataDetail() {
            this.$emit('Datadetail', this.data_detail, this.num);
            this.mtdClose();
        },
        uploadImage(event, type) {
            const file = event.target.files[0];
            if (file) {
                this.data_detail[type] = file;
            }
        }
    },
};
</script>
